/**
 *
 * @module locale
 *
 */

import Check from 'check-types';
import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    nonEmptyString,
    nonEmptyObject
} = Check.assert;

/**
 *
 * @class Locale
 *
 */
export default class Locale {

    /**
     *
     * @param {Object} options
     * @param {String} [options.description=undefined]
     * @param {Number} [options.id=0]
     * @param {String} [options.isoCountryCode=undefined]
     * @param {String} [options.isoLanguageCode=undefined]
     * @param {String} [options.name='']
     * @throws {InvalidArgumentException}
     *
     */
    constructor(options) {

        const errorMessage = {
            ctor: 'Locale(options)',
            get options() {
                return `${this.ctor} options should be an Object`;
            },
            get description() {
                return `${this.ctor} description should be a String with length`;
            },
            get id() {
                return `${this.ctor} id should be a Number`;
            },
            get isoCountryCode() {
                return `${this.ctor} isoCountryCode should be a String with length`;
            },
            get isoLanguageCode() {
                return `${this.ctor} isoLanguageCode should be a String with length`;
            },
            get name() {
                return `${this.ctor} name should be a String with length`;
            }
        };

        nonEmptyObject(options, errorMessage.options, InvalidArgumentException);

        const { description, id, isoCountryCode, isoLanguageCode, name } = options;

        if (Check.assigned(description)) {
            nonEmptyString(description, errorMessage.description, InvalidArgumentException);
        }

        if (Check.assigned(isoCountryCode)) {
            nonEmptyString(isoCountryCode, errorMessage.isoCountryCode, InvalidArgumentException);
        }

        if (Check.assigned(isoLanguageCode)) {
            nonEmptyString(isoLanguageCode, errorMessage.isoLanguageCode, InvalidArgumentException);
        }

        if (Check.assigned(name)) {
            nonEmptyString(name, errorMessage.name, InvalidArgumentException);
        }

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.description = description;

        /**
         *
         * @access public
         * @type {Number}
         *
         */
        this.id = Check.number(id) ? id : 0;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.isoCountryCode = isoCountryCode;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.isoLanguageCode = isoLanguageCode;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.name = Check.string(name) ? name : '';

    }

}



// WEBPACK FOOTER //
// ./src/services/commerce/locale.js